//Book[Identifier] A_ : Level1   B_ : Level2 ....
export const BookIdentifier = {
    A_IMGLINKS:'imageLinks',
    A_TITLE:'title',
    A_PUBLISHEDDATE:'publishedDate',
    A_ID:'id',
    A_DESCRIPTION:'description',
    A_AUTHORS:'authors', 
    A_SHELF:'shelf',
    B_THUMBNAIL:'smallThumbnail',
};


// WEBPACK FOOTER //
// ./src/constant/Identifiers.js